import { render, staticRenderFns } from "./SetDomain.vue?vue&type=template&id=786745bc"
import script from "./SetDomain.vue?vue&type=script&lang=js"
export * from "./SetDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports